
// Delayed Modal Display + Cookie On Click
$(document).ready(function() {
    const headerPromo = $('.promoHead'),
          closePromoButton = $('.userMenuCloseButton',headerPromo);
    if ( headerPromo.length && $.cookie("no_promo_thanks") == null) {
            headerPromo.removeClass('none');
    }
    closePromoButton.click(function() {
        headerPromo.addClass('none');
        document.cookie = "no_promo_thanks=true; expires=Fri, 31 Dec 9999 23:59:59 UTC";
    });
});
